import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export type I_RegistEmailInfo = {
    login_id: string
    password: string
};

export const getUserInfo = (data: I_RegistEmailInfo): Promise<I_RegistEmailInfo> => {
  return axios.post(`${API_URL_MAIN}/authorize/get_user_info`, data);
};
